import { XhrHttpHandler } from '@aws-sdk/xhr-http-handler';
import { apiSlice } from '../../app/services/apiSlice';
import staticApiResponses from './data/StaticThemeSettings.json';
import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import axios from 'axios';
import { checkImageURL } from '../../utils/helper';

const VENDOR = 'vendor';

const VENDORS_URL = 'vendor/florist';

const AUTHENTIC_URL = 'authentication/user/florist/';

const VENDORS_URL1 = 'vendor/api';

const APIV2 = '/v2';

export const vendorsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addVendor: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL}`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    getVendorsUsers: builder.query({
      query: (params) => ({
        url: `${AUTHENTIC_URL}${params}`,
      }),
    }),

    getVendors: builder.query({
      query: (params) => ({
        url: `${VENDORS_URL}`,
        params: { ...params },
      }),
    }),

    getAllFloristLatLng: builder.query({
      query: (params) => ({
        url: `${VENDORS_URL}/get-all-flower-shops-with-lat-long`,
        params: { ...params },
      }),
    }),

    getAllFloristByRadius: builder.query({
      query: (params) => ({
        url: `${VENDORS_URL}/byRadius`,
        params: { ...params },
      }),
    }),

    getAllFloristByRadiusPublic: builder.query({
      query: (params) => ({
        url: `${VENDORS_URL}/public/byRadius`,
        params: { ...params },
      }),
    }),

    getVendorDropDown: builder.mutation({
      query: (params) => ({
        url: `${VENDORS_URL}`,
        params: { ...params, perPage: 20 },
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.objectData?.content?.map(
          (vendor) => ({
            ...vendor,
            id: vendor?.id,
            title: `${
              vendor?.companyName
                ? vendor?.companyName
                : vendor?.contactFirstName || '' + vendor?.contactLastName || ''
            }`,
          }),
        );
        return responseData || {};
      },
    }),

    getProductCategories: builder.mutation({
      query: (params) => ({
        url: `inventory/invTag`,
        params: { ...params, perPage: 20 },
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.objectData?.content?.map(
          (category) => ({
            ...category,
            value: category?.id,
            title: `${category?.name}`,
          }),
        );
        return responseData || {};
      },
    }),

    getImageTags: builder.mutation({
      query: (params) => ({
        method: 'GET',
        url: `/vendor/api/imageTag`,
        params: { ...params, perPage: 20 },
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.objectData?.content?.map(
          (category) => ({
            ...category,
            value: category?.id,
            title: `${category?.name}`,
          }),
        );
        return responseData || {};
      },
    }),

    getImageCategories: builder.mutation({
      query: () => ({
        method: 'GET',
        url: `/vendor/api/floristImages/category-list`,
      }),
    }),

    updateImageCategoriesInBulk: builder.mutation({
      query: (data) => ({
        url: `/vendor/api/floristImages/assign-category`,
        method: 'POST',
        body: data,
      }),
    }),

    getAllNewCategories: builder.mutation({
      query: (params) => ({
        url: `inventory/api/category`,
        params: { ...params, perPage: 20 },
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.objectData?.content?.map(
          (category) => ({
            ...category,
            value: category?.id,
            title: `${category?.name}`,
          }),
        );
        return responseData || {};
      },
    }),

    getChannelId: builder.query({
      query: (data) => ({
        url: `authentication/chat`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    getFloristDropDown: builder.query({
      query: () => ({
        url: `${VENDORS_URL1}/floralServices/getAllForDropDown`,
      }),
    }),

    getFloristDropDownPublic: builder.query({
      query: () => ({
        url: `${VENDORS_URL1}/floralServices/public/getAllForDropDown`,
      }),
    }),

    getFavoriteFlorist: builder.query({
      query: (params) => ({
        url: `${VENDORS_URL1}/favoriteFlorist/${params}`,
      }),
    }),

    addFloristAsFavorite: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/favoriteFlorist`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    removeFloristFromFavorite: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/favoriteFlorist/${data}`,
        method: 'DELETE',
      }),
    }),
    //   query: (data) => ({
    //     url: `${VENDORS_URL}`,
    //     method: 'POST',
    //     body: { ...data },
    //   }),
    // }),

    addFooter: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/footerData`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    updateFooter: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/footerData`,
        method: 'PUT',
        body: { ...data },
      }),
    }),

    getFooter: builder.query({
      query: () => ({
        url: `${VENDORS_URL1}/footerData/getByFloristId`,
      }),
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),

    addHeader: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/templateHeader`,
        method: 'POST',
        body: { ...data },
      }),
      invalidatesTags: ['templateData'],
    }),

    updateHeader: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/templateHeader`,
        method: 'PUT',
        body: { ...data },
      }),
      invalidatesTags: ['templateData'],
    }),

    getHeader: builder.query({
      query: () => ({
        url: `${VENDORS_URL1}/templateHeader/getByFloristId`,
      }),
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),

    deleteFooterSubMenu: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/templateHeader/deleteFooterInfoOption/${data?.id}`,
        method: 'delete',
      }),
    }),

    getTemplatedata: builder.query({
      query: () => ({
        url: `${VENDORS_URL1}/settings/template/predefined`,
      }),

      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),

    getTemplateSelectedData: builder.query({
      query: () => ({
        url: `${VENDORS_URL1}/settings/template/selected`,
      }),
      providesTags: ['templateData'],
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),

    updateTemplateData: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/settings/template`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    changeTemplateData: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/settings/template/changeTemplate`,
        method: 'POST',
        body: { ...data },
      }),
      invalidatesTags: ['templateData'],
    }),

    resetTemplateData: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/settings/template/resetTemplate`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    updateTemplatePageSectionData: builder.mutation({
      query: ({ pId, data }) => ({
        url: `${VENDORS_URL1}/settings/template/pages/${pId}/sections`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    deleteSectionsData: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/settings/template/deletePageSectionDetail/${data}`,
        method: 'delete',
      }),
    }),

    deletePageSection: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/settings/template/deletePageSection/${data}`,
        method: 'delete',
      }),
    }),

    createNewPage: builder.mutation({
      query: ({ tId, data }) => ({
        url: `${VENDORS_URL1}/settings/template/${tId}/pages`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    updatePageOrder: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/settings/template/rearrange/pages`,
        method: 'POST',
        body: data,
      }),
    }),

    copyExistingPage: builder.mutation({
      query: ({ pId }) => ({
        url: `${VENDORS_URL1}/settings/template/page/${pId}/duplicate`,
        method: 'POST',
      }),
    }),

    reorderPageSections: builder.mutation({
      query: ({ data }) => ({
        url: `${VENDORS_URL1}/settings/template/pages/reorder`,
        method: 'POST',
        body: data,
      }),
      // invalidatesTags: ['templateData'],
    }),

    updateTemplatePageSectionDetail: builder.mutation({
      query: ({ sId, data }) => ({
        url: `${VENDORS_URL1}/settings/template/pages/sections/${sId}/details`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    getSocialMediaDetails: builder.mutation({
      query: (id) => ({
        url: `${VENDORS_URL1}/socialMedia/getByFloristId/${id}`,
      }),

      transformResponse: (responseData) => {
        const dataExists = responseData?.objectData?.socialMediaDTOS?.length;
        let mergedLinks;
        if (dataExists) {
          const apiLinks = responseData?.objectData?.socialMediaDTOS;
          const staticLinks = staticApiResponses.socialMediaLinks;

          const apiNames = new Set(apiLinks.map((item) => item.name));

          mergedLinks = [
            ...apiLinks,
            ...staticLinks.filter((item) => !apiNames.has(item.name)),
          ];
        }
        return dataExists
          ? mergedLinks
          : staticApiResponses.socialMediaLinks;
      },
    }),

    updateSocialMediaDetails: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/socialMedia`,
        method: 'PUT',
        body: { ...data },
      }),
    }),

    getFavicon: builder.mutation({
      query: () => ({
        url: `${VENDORS_URL1}/templateData/getByFloristId`,
      }),

      transformResponse: (responseData) => {
        return responseData?.objectData?.faviconUrl;
      },
    }),

    updateFavicon: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/templateData/addFaviconUrl`,
        method: 'POST',
        body: { ...data },
      }),
    }),

    deleteTemplatePage: builder.mutation({
      query: (id) => ({
        url: `${VENDORS_URL1}/settings/template/deletedPage/${id}`,
        method: 'DELETE',
      }),
    }),

    getAllInquiries: builder.query({
      query: (id) => ({
        url: `${VENDORS_URL1}/contactUs/getByFloristId/${id}`,
      }),
      transformResponse: (responseData) => {
        return responseData?.objectData;
      },
    }),

    getPredefinedPolicies: builder.query({
      query: (params) => ({
        url: `${VENDOR}/floristPolicy/predefined`,
        params,
      }),
    }),

    getAvailableSectionList: builder.query({
      query: () => ({
        url: `${VENDORS_URL1}/tableSection`,
      }),

      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),

    getTemplateColorPalettes: builder.query({
      query: (tId) => ({
        url: `${VENDORS_URL1}/settings/template/${tId}/themes`,
      }),

      transformResponse: (responseData) => {
        return responseData?.objectData
          ? responseData?.objectData.map((item) => {
              const parsedValue = item.value ? JSON.parse(item.value) : {};
              return {
                ...item,
                value: parsedValue,
                type: item.type ?? 'normal',
              };
            })
          : [];
      },
    }),

    updateColorPalette: builder.mutation({
      query: ({ tId, data }) => {
        return {
          url: `${VENDORS_URL1}/settings/template/${tId}/themes`,
          method: 'POST',
          body: { ...data },
        };
      },
    }),

    deleteColorPalette: builder.mutation({
      query: ({ tId, id }) => {
        return {
          url: `${VENDORS_URL1}/settings/template/${tId}/themes/${id}`,
          method: 'DELETE',
        };
      },
    }),

    getTypographyDetails: builder.query({
      query: (id) => ({
        url: `${VENDORS_URL1}/typography/getByFloristId/${id}`,
      }),

      transformResponse: (responseData) => {
        const dataExists =
          responseData?.objectData?.typographyDetailsDTOS?.length;
        return dataExists
          ? responseData?.objectData?.typographyDetailsDTOS
          : [];
      },
    }),

    updateTypographyDetails: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/typography`,
        method: 'PUT',
        body: { ...data },
      }),
    }),

    getTemplateTypographyDetails: builder.query({
      query: (tId) => ({
        url: `${VENDORS_URL1}/settings/template/${tId}/typography`,
      }),

      transformResponse: (responseData) => {
        const formattedData =
          responseData?.objectData?.map((item) => ({
            ...item,
            value: JSON.parse(item.value ?? {}),
          })) ?? [];
        return formattedData;
      },
    }),

    updateTemplateTypographyDetails: builder.mutation({
      query: ({ tId, data }) => {
        return {
          url: `${VENDORS_URL1}/settings/template/${tId}/typography`,
          method: 'POST',
          body: { ...data },
        };
      },
    }),

    getButtonDetails: builder.query({
      query: (id) => ({
        url: `${VENDORS_URL1}/button/getByFloristId/${id}`,
      }),

      transformResponse: (responseData) => {
        return responseData?.objectData?.buttonDTOS;
      },
    }),

    updateButtonDetails: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/button`,
        method: 'PUT',
        body: { ...data },
      }),
    }),

    getTemplateButtonDetails: builder.query({
      query: (tId) => ({
        url: `${VENDORS_URL1}/settings/template/${tId}/buttons`,
      }),

      transformResponse: (responseData) => {
        const formattedData =
          responseData?.objectData?.map((data) => ({
            ...data,
            value: JSON.parse(data.value ?? {}),
          })) ?? [];
        return formattedData;
      },
    }),

    getTemplateDetailsByFloristId: builder.query({
      query: () => ({
        url: `${VENDORS_URL1}/templateData/getByFloristId`,
      }),

      transformResponse: (responseData) => {
        return responseData?.objectData;
      },
    }),

    updateTemplateButtonsDetails: builder.mutation({
      query: ({ tId, data }) => {
        return {
          url: `${VENDORS_URL1}/settings/template/${tId}/buttons`,
          method: 'POST',
          body: { ...data },
        };
      },
    }),

    publishWebsite: builder.mutation({
      query: (data) => {
        return {
          url: `/authentication/auth/register-domain`,
          method: 'POST',
          body: { ...data },
        };
      },
    }),

    getOrders: builder.mutation({
      query: (params) => ({
        url: `inventory/api/customerCart${APIV2}`,
        params,
      }),
      transformResponse: (response) => response?.objectData,
    }),

    getOrderDetails: builder.query({
      query: ({ uuid }) => ({
        url: `inventory/api/customerCart/uuid/${uuid}`,
      }),
      providesTags: ['OrderDetails'],
      transformResponse: (response) => response?.objectData,
    }),

    getFinancialReport: builder.query({
      query: (params) => ({
        url: `/inventory/api/customerCart/getFinancialReport`,
        params,
      }),
      transformResponse: (response) => response?.objectData,
    }),

    loadToPOS: builder.mutation({
      query: (data) => ({
        url: `inventory/api/customerCart/resend-to-pos`,
        method: 'PUT',
        body: { ...data },
      }),
      transformResponse: (response) => response?.objectData,
    }),

    publishWebsiteByFlorist: builder.mutation({
      query: () => ({
        url: `${VENDORS_URL1}/publishTemplate/publishByFloristId`,
        method: 'POST',
      }),
      transformResponse: (response) => response,
    }),

    updateAnalyticsId: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/templateData/addAnalyticsId`,
        method: 'POST',
        body: { ...data },
      }),
      transformResponse: (response) => response?.objectData,
    }),

    getPageSeoData: builder.query({
      query: ({ pageId }) => ({
        url: `${VENDORS_URL1}/seo-meta/getByPageId/${pageId}`,
      }),
      transformResponse: (response) => response?.objectData,
    }),

    updatePageSeoData: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/seo-meta`,
        method: 'POST',
        body: { ...data },
      }),
      invalidatesTags: ['templateData'],
      transformResponse: (response) => response,
    }),

    // Promotion Banners
    getPromotionBannerData: builder.query({
      query: ({ id }) => ({
        url: `${VENDORS_URL1}/promotionalBanner/${id}`,
      }),
      providesTags: ['PromotionalBanner'],
      transformResponse: (response) => response?.objectData,
    }),

    updatePromotionBannerData: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/promotionalBanner`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['PromotionalBanner', 'templateData'],
      transformResponse: (response) => response,
    }),
    updateGoogleVerificationKey: builder.mutation({
      query: ({ floristId, data }) => {
        return {
          url: `${VENDORS_URL}/${floristId}/google/verification/snippet`,
          method: 'PUT',
          body: { ...data },
        };
      },
    }),
    updateShopCartSetttings: builder.mutation({
      query: (data) => ({
        url: `${VENDORS_URL1}/templateData/shop/cart/settings`,
        method: 'POST',
        body: data,
      }),
      transformResponse: (response) => response,
    }),
    getShopCartSetttings: builder.query({
      query: () => ({
        url: `${VENDORS_URL1}/templateData/fetch/shop/cart/settings`,
      }),
      transformResponse: (response) => response?.objectData,
    }),

    refundOrder: builder.mutation({
      query: (data) => ({
        url: `inventory/api/customerCart/refund`,
        method: 'POST',
        body: data,
      }),
      transformResponse: (response) => response,
    }),

    generateOrderReport: builder.mutation({
      query: (params) => ({
        url: `inventory/api/customerCart/download/excel/`,
        method: 'GET',
        params: params,
        responseHandler: (response) => response.blob(), // Ensures the response is handled as a Blob (for file downloads)
      }),
    }),

    generateSalesReport: builder.mutation({
      query: (params) => ({
        url: `/inventory/api/customerCart/summary/download/excel`,

        method: 'GET',
        params: params,
        responseHandler: (response) => response.blob(), // Ensures the response is handled as a Blob (for file downloads)
      }),
    }),

    uploadHeroImageToS3Bucket: builder.mutation({
      queryFn: async (data, _api, _extraOptions, baseQuery) => {
        const { reqData, updatedImageIndices, sizes } = data;

        const s3 = new S3Client({
          region: process.env.REACT_APP_S3_BUCKET_REGION,
          requestHandler: new XhrHttpHandler({}),
        });

        const processImage = async (image) => {
          return new Promise(async (resolve, reject) => {
            try {
              const response = await fetch(image?.imageUrl);
              const blob = await response.blob();

              const isGif = image?.imageUrl?.toLowerCase().endsWith('.gif');

              // Handle GIFs separately
              if (isGif) {
                const reader = new FileReader();
                reader.onload = () => {
                  resolve({
                    data: reader.result, // Base64 string for GIF
                    contentType: 'image/gif',
                  });
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
                return;
              }

              const reader = new FileReader();
              reader.onload = () => {
                const imageData = new Image();
                imageData.src = reader.result;

                imageData.onload = () => {
                  const canvas = document.createElement('canvas');
                  const ctx = canvas.getContext('2d');
                  const recommendedWidth = sizes[0];
                  const recommendedHeight = sizes[1];

                  // Current canvas dimensions
                  const currentCanvasWidth =
                    image?.extraProps?.canvaswidth || imageData.naturalWidth;
                  const currentCanvasHeight =
                    image?.extraProps?.canvasHeight || imageData.naturalHeight;

                  // Scaling factors based on width and height
                  const scaleWidth = recommendedWidth / currentCanvasWidth;
                  const scaleHeight = recommendedHeight / currentCanvasHeight;

                  // Use the smaller scaling factor to ensure the aspect ratio remains consistent
                  const scalingFactor = Math.min(scaleWidth, scaleHeight);

                  // New canvas dimensions
                  canvas.width = currentCanvasWidth * scalingFactor;
                  canvas.height = currentCanvasHeight * scalingFactor;

                  // Clear the canvas and set image smoothing
                  ctx.clearRect(0, 0, canvas.width, canvas.height);
                  ctx.imageSmoothingQuality = 'high';

                  // Adjust the image dimensions and translation based on scaling
                  const translationX =
                    (image?.extraProps?.translation?.x || 0) * scalingFactor;
                  const translationY =
                    (image?.extraProps?.translation?.y || 0) * scalingFactor;

                  const imgWidth =
                    (image?.extraProps?.imgWidth || currentCanvasWidth) *
                    scalingFactor;
                  const imgHeight =
                    (image?.extraProps?.imgHeight || currentCanvasHeight) *
                    scalingFactor;

                  // Draw the image onto the canvas
                  ctx.drawImage(
                    imageData,
                    0,
                    0,
                    imageData.naturalWidth,
                    imageData.naturalHeight,
                    translationX,
                    translationY,
                    imgWidth,
                    imgHeight,
                  );
                  const contentTypes = 'image/webp';
                  // Convert canvas to base64
                  const dataURL = canvas.toDataURL(contentTypes);
                  const base64Data = dataURL.split(',')[1]; // Remove the prefix
                  const binaryData = atob(base64Data);
                  const arrayBuffer = new ArrayBuffer(binaryData.length);
                  const uint8Array = new Uint8Array(arrayBuffer);

                  for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                  }

                  const blob = new Blob([uint8Array], { type: contentTypes });

                  resolve({
                    data: blob, // Extract Base64 data
                    contentType: contentTypes,
                  });
                };
                imageData.onerror = reject;
              };

              reader.onerror = reject;
              reader.readAsDataURL(blob);

            } catch (error) {
              console.error('Error in processImage: ', error);
              reject(error);
            }
          });
        };

        try {
          if (!reqData?.details?.length) {
            return { data: null };
          }

          const updatedDataDetails = await Promise.all(
            reqData.details.map(async (element, index) => {
              if (
                !element?.extraProps ||
                Object.keys(element?.extraProps).length === 0 ||
                !updatedImageIndices.includes(index)
              ) {
                return element;
              }

              try {
                const processedImage = await processImage(element);


                if (!processedImage?.data) {
                  throw new Error('Image processing failed');
                }

                const newFileName = `${element.id || Date.now()}${Date.now()}.${
                  processedImage.contentType.split('/')[1]
                }`;

                const imagePath = `website-sections-images/hero-image-gallery/${newFileName}`;

                const preSignedUrlPayload = {
                  bucketName: process.env.REACT_APP_S3_BUCKET_UPLOAD_URL,
                  path: imagePath,
                  contentType: processedImage.contentType,
                };

                const response = await baseQuery({
                  url: `vendor/api/floristImages/generatePresignedUrl`,
                  method: 'POST',
                  body: { ...preSignedUrlPayload },
                });

                const presignedUrl = response?.error?.data
                .replace(/^Presigned URL:\s*/, '')
                .trim();

                const fileBuffer = await processedImage?.data?.arrayBuffer();

                await axios.put(presignedUrl, fileBuffer, {
                   headers: {
                     'Content-Type':  processedImage.contentType,
                   },
                 });

                const s3BucketUrl = `https://${process.env.REACT_APP_S3_BUCKET_URL}/${imagePath}`;
                await checkImageURL(s3BucketUrl , true);

                return {
                  ...element,
                  extraProps: {
                    ...element?.extraProps,
                    processedImage: s3BucketUrl,
                  },
                };
              } catch (error) {
                console.error(
                  `Failed to process/upload image for element ${element.id}:`,
                  error,
                );
                return {
                  ...element,
                  extraProps: {
                    ...element?.extraProps,
                    processedImage: null,
                  },
                };
              }
            }),
          );

          const updatedData = { ...reqData, details: updatedDataDetails };
          return { data: updatedData };
        } catch (error) {
          console.error('Upload operation failed:', error);
          return { error: error.message };
        }
      },
    }),

    uploadCarouselImageToS3Bucket: builder.mutation({
      queryFn: async (data, _api, _extraOptions, baseQuery) => {
        const {
          reqData,
          updatedImageIndices,
          editMenuIndex,
          recommendedImageSizes,
          widthType,
        } = data;

        const s3 = new S3Client({
          region: process.env.REACT_APP_S3_BUCKET_REGION,
          requestHandler: new XhrHttpHandler({}),
        });

        const processImage = async (image, index) => {
          return new Promise(async (resolve, reject) => {
            try {
              const response = await fetch(image?.imageUrl);
              const blob = await response.blob();

              const isGif = image?.imageUrl?.toLowerCase().endsWith('.gif');

              // Handle GIFs separately
              if (isGif) {
                const reader = new FileReader();
                reader.onload = () => {
                  resolve({
                    data: reader.result, // Base64 string for GIF
                    contentType: 'image/gif',
                  });
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
                return;
              }

              const reader = new FileReader();
              reader.onload = () => {
                const imageData = new Image();
                imageData.src = reader.result;

                imageData.onload = () => {
                  const canvas = document.createElement('canvas');
                  const ctx = canvas.getContext('2d');
                  const recommendedImageSize =
                    editMenuIndex === 4 && widthType === 'full'
                      ? '1200 x 600'
                      : editMenuIndex === 6
                      ? index === 0
                        ? '600 x 500'
                        : '600 x 245'
                      : recommendedImageSizes[editMenuIndex];
                  const sizes = recommendedImageSize
                    .split('x')
                    .map((size) => parseInt(size.trim()));

                  const recommendedWidth = sizes[0];
                  const recommendedHeight = sizes[1];

                  // Current canvas dimensions
                  const currentCanvasWidth =
                    image?.extraProps?.canvaswidth || imageData.naturalWidth;
                  const currentCanvasHeight =
                    image?.extraProps?.canvasHeight || imageData.naturalHeight;

                  // Scaling factors based on width and height
                  const scaleWidth = recommendedWidth / currentCanvasWidth;
                  const scaleHeight = recommendedHeight / currentCanvasHeight;

                  // Use the smaller scaling factor to ensure the aspect ratio remains consistent
                  const scalingFactor = Math.min(scaleWidth, scaleHeight);

                  // New canvas dimensions
                  canvas.width = currentCanvasWidth * scalingFactor;
                  canvas.height = currentCanvasHeight * scalingFactor;

                  // Clear the canvas and set image smoothing
                  ctx.clearRect(0, 0, canvas.width, canvas.height);
                  ctx.imageSmoothingQuality = 'high';

                  // Adjust the image dimensions and translation based on scaling
                  const translationX =
                    (image?.extraProps?.translation?.x || 0) * scalingFactor;
                  const translationY =
                    (image?.extraProps?.translation?.y || 0) * scalingFactor;

                  const imgWidth =
                    (image?.extraProps?.imgWidth || currentCanvasWidth) *
                    scalingFactor;
                  const imgHeight =
                    (image?.extraProps?.imgHeight || currentCanvasHeight) *
                    scalingFactor;

                  // Draw the image onto the canvas
                  ctx.drawImage(
                    imageData,
                    0,
                    0,
                    imageData.naturalWidth,
                    imageData.naturalHeight,
                    translationX,
                    translationY,
                    imgWidth,
                    imgHeight,
                  );
                  const contentTypes = 'image/webp';
                  // Convert canvas to base64
                  const dataURL = canvas.toDataURL(contentTypes);
                  const base64Data = dataURL.split(',')[1]; // Remove the prefix
                  const binaryData = atob(base64Data);
                  const arrayBuffer = new ArrayBuffer(binaryData.length);
                  const uint8Array = new Uint8Array(arrayBuffer);

                  for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                  }

                  const blob = new Blob([uint8Array], { type: contentTypes });

                  resolve({
                    data: blob, // Extract Base64 data
                    contentType: contentTypes,
                  });
                };
                imageData.onerror = reject;
              };

              reader.onerror = reject;
              reader.readAsDataURL(blob);
            } catch (error) {
              console.error('Error in processImage: ', error);
              reject(error);
            }
          });
        };

        try {
          if (!reqData?.details?.length) {
            return { data: null };
          }

          const updatedDataDetails = await Promise.all(
            reqData.details.map(async (element, index) => {
              if (
                !element?.extraProps ||
                Object.keys(element?.extraProps).length === 0 ||
                !updatedImageIndices.includes(index)
              ) {
                return element;
              }

              try {
                const processedImage = await processImage(element, index);

                if (!processedImage?.data) {
                  throw new Error('Image processing failed');
                }

                const newFileName = `${element.id || Date.now()}${Date.now()}.${
                  processedImage.contentType.split('/')[1]
                }`;

                const imagePath = `website-sections-images/carousel-image-gallery/${newFileName}`;

                const preSignedUrlPayload = {
                  bucketName: process.env.REACT_APP_S3_BUCKET_UPLOAD_URL,
                  path: imagePath,
                  contentType: processedImage.contentType,
                };

                
                const response = await baseQuery({
                  url: `vendor/api/floristImages/generatePresignedUrl`,
                  method: 'POST',
                  body: { ...preSignedUrlPayload },
                });

                const presignedUrl = response?.error?.data
                .replace(/^Presigned URL:\s*/, '')
                .trim();

                const fileBuffer = await processedImage?.data?.arrayBuffer();

                await axios.put(presignedUrl, fileBuffer, {
                   headers: {
                     'Content-Type':  processedImage.contentType,
                   },
                 });

                const s3BucketUrl = `https://${process.env.REACT_APP_S3_BUCKET_URL}/${imagePath}`;
                await checkImageURL(s3BucketUrl , true);

                return {
                  ...element,
                  extraProps: {
                    ...element?.extraProps,
                    processedImage: s3BucketUrl,
                  },
                };
              } catch (error) {
                console.error(
                  `Failed to process/upload image for element ${element.id}:`,
                  error,
                );
                return {
                  ...element,
                  extraProps: {
                    ...element?.extraProps,
                    processedImage: null,
                  },
                };
              }
            }),
          );

          const updatedData = { ...reqData, details: updatedDataDetails };
          return { data: updatedData };
        } catch (error) {
          console.error('Upload operation failed:', error);
          return { error: error.message };
        }
      },
    }),

    uploadFeaturedCategoryImageToS3Bucket: builder.mutation({
      queryFn: async (data, _api, _extraOptions, baseQuery) => {
        const {
          reqData,
          updatedImageIndices,
          recommendedFullWidthImageSizes,
          editMenuIndex,
        } = data;

        const s3 = new S3Client({
          region: process.env.REACT_APP_S3_BUCKET_REGION,
          requestHandler: new XhrHttpHandler({}),
        });

        const processImage = async (image, imageSelectedIndex) => {
          return new Promise(async (resolve, reject) => {
            try {
              const response = await fetch(image?.imageUrl);
              const blob = await response.blob();

              const isGif = image?.imageUrl?.toLowerCase().endsWith('.gif');

              // Handle GIFs separately
              if (isGif) {
                const reader = new FileReader();
                reader.onload = () => {
                  resolve({
                    data: reader.result, // Base64 string for GIF
                    contentType: 'image/gif',
                  });
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
                return;
              }

              function getDimensions(index) {
                if (index % 3 === 0) {
                  return '650 x 500';
                } else {
                  return '650 x 250';
                }
              }

              const reader = new FileReader();
              reader.onload = () => {
                const imageData = new Image();
                imageData.src = reader.result;

                imageData.onload = () => {
                  const canvas = document.createElement('canvas');
                  const ctx = canvas.getContext('2d');
                  const recommendedImageSize =
                    editMenuIndex === 1
                      ? getDimensions(imageSelectedIndex)
                      : editMenuIndex === 0
                      ? '350 x 350'
                      : recommendedFullWidthImageSizes[editMenuIndex];

                  const sizes = recommendedImageSize
                    .split('x')
                    .map((size) => parseInt(size.trim()));

                  const recommendedWidth = sizes[0];
                  const recommendedHeight = sizes[1];

                  // Current canvas dimensions
                  const currentCanvasWidth =
                    image?.extraProps?.canvaswidth || imageData.naturalWidth;
                  const currentCanvasHeight =
                    image?.extraProps?.canvasHeight || imageData.naturalHeight;

                  // Scaling factors based on width and height
                  const scaleWidth = recommendedWidth / currentCanvasWidth;
                  const scaleHeight = recommendedHeight / currentCanvasHeight;

                  // Use the smaller scaling factor to ensure the aspect ratio remains consistent
                  const scalingFactor = Math.min(scaleWidth, scaleHeight);

                  // New canvas dimensions
                  canvas.width = currentCanvasWidth * scalingFactor;
                  canvas.height = currentCanvasHeight * scalingFactor;

                  // Clear the canvas and set image smoothing
                  ctx.clearRect(0, 0, canvas.width, canvas.height);
                  ctx.imageSmoothingQuality = 'high';

                  // Adjust the image dimensions and translation based on scaling
                  const translationX =
                    (image?.extraProps?.translation?.x || 0) * scalingFactor;
                  const translationY =
                    (image?.extraProps?.translation?.y || 0) * scalingFactor;

                  const imgWidth =
                    (image?.extraProps?.imgWidth || currentCanvasWidth) *
                    scalingFactor;
                  const imgHeight =
                    (image?.extraProps?.imgHeight || currentCanvasHeight) *
                    scalingFactor;

                  // Draw the image onto the canvas
                  ctx.drawImage(
                    imageData,
                    0,
                    0,
                    imageData.naturalWidth,
                    imageData.naturalHeight,
                    translationX,
                    translationY,
                    imgWidth,
                    imgHeight,
                  );
                  const contentTypes = 'image/webp';
                  // Convert canvas to base64
                  const dataURL = canvas.toDataURL(contentTypes);
                  const base64Data = dataURL.split(',')[1]; // Remove the prefix
                  const binaryData = atob(base64Data);
                  const arrayBuffer = new ArrayBuffer(binaryData.length);
                  const uint8Array = new Uint8Array(arrayBuffer);

                  for (let i = 0; i < binaryData.length; i++) {
                    uint8Array[i] = binaryData.charCodeAt(i);
                  }

                  const blob = new Blob([uint8Array], { type: contentTypes });

                  resolve({
                    data: blob, // Extract Base64 data
                    contentType: contentTypes,
                  });
                };
                imageData.onerror = reject;
              };

              reader.onerror = reject;
              reader.readAsDataURL(blob);
            } catch (error) {
              console.error('Error in processImage: ', error);
              reject(error);
            }
          });
        };

        try {
          if (!reqData?.details?.length) {
            return { data: null };
          }

          const updatedDataDetails = await Promise.all(
            reqData.details.map(async (element, index) => {
              if (
                !element?.extraProps ||
                Object.keys(element?.extraProps).length === 0 ||
                !updatedImageIndices.includes(index)
              ) {
                return element;
              }

              try {
                const processedImage = await processImage(element, index);

                if (!processedImage?.data) {
                  throw new Error('Image processing failed');
                }

                const newFileName = `${element.id || Date.now()}${Date.now()}.${
                  processedImage.contentType.split('/')[1]
                }`;

                const imagePath = `website-sections-images/featured-category-image-gallery/${newFileName}`;

                const preSignedUrlPayload = {
                  bucketName: process.env.REACT_APP_S3_BUCKET_UPLOAD_URL,
                  path: imagePath,
                  contentType: processedImage.contentType,
                };
                
                const response = await baseQuery({
                  url: `vendor/api/floristImages/generatePresignedUrl`,
                  method: 'POST',
                  body: { ...preSignedUrlPayload },
                });

                const presignedUrl = response?.error?.data
                .replace(/^Presigned URL:\s*/, '')
                .trim();

                const fileBuffer = await processedImage?.data?.arrayBuffer();

                await axios.put(presignedUrl, fileBuffer, {
                   headers: {
                     'Content-Type':  processedImage.contentType,
                   },
                 });

                const s3BucketUrl = `https://${process.env.REACT_APP_S3_BUCKET_URL}/${imagePath}`;
                await checkImageURL(s3BucketUrl , true);

                return {
                  ...element,
                  extraProps: {
                    ...element?.extraProps,
                    processedImage: s3BucketUrl,
                  },
                };
              } catch (error) {
                console.error(
                  `Failed to process/upload image for element ${element.id}:`,
                  error,
                );

                return {
                  ...element,
                  extraProps: {
                    ...element?.extraProps,
                    processedImage: null,
                  },
                };
              }
            }),
          );

          const updatedData = { ...reqData, details: updatedDataDetails };
          return { data: updatedData };
        } catch (error) {
          console.error('Upload operation failed:', error);
          return { error: error.message };
        }
      },
    }),
  }),
});

export const {
  useUpdateGoogleVerificationKeyMutation,
  useAddVendorMutation,
  useGetVendorsQuery,
  useGetAllFloristLatLngQuery,
  useGetVendorDropDownMutation,
  useGetProductCategoriesMutation,
  useGetAllNewCategoriesMutation,
  useGetChannelIdQuery,
  useGetAllFloristByRadiusQuery,
  useGetVendorsUsersQuery,
  useGetFloristDropDownQuery,
  useGetFavoriteFloristQuery,
  useAddFloristAsFavoriteMutation,
  useRemoveFloristFromFavoriteMutation,
  useGetFloristDropDownPublicQuery,
  useGetAllFloristByRadiusPublicQuery,
  useAddFooterMutation,
  useGetFooterQuery,
  useUpdateFooterMutation,
  useAddHeaderMutation,
  useGetHeaderQuery,
  useUpdateHeaderMutation,
  useGetTemplatedataQuery,
  useGetTemplateSelectedDataQuery,
  useUpdateTemplateDataMutation,
  useChangeTemplateDataMutation,
  useResetTemplateDataMutation,
  useUpdateTemplatePageSectionDataMutation,
  useDeleteSectionsDataMutation,
  useDeletePageSectionMutation,
  useCreateNewPageMutation,
  useUpdatePageOrderMutation,
  useCopyExistingPageMutation,
  useReorderPageSectionsMutation,
  useUpdateTemplatePageSectionDetailMutation,
  useGetSocialMediaDetailsMutation,
  useUpdateSocialMediaDetailsMutation,

  useGetAvailableSectionListQuery,
  useUpdateFaviconMutation,
  useGetFaviconMutation,
  useGetImageTagsMutation,
  useDeleteTemplatePageMutation,
  useGetAllInquiriesQuery,
  useGetPredefinedPoliciesQuery,
  useUploadHeroImageToS3BucketMutation,
  useUploadCarouselImageToS3BucketMutation,
  useUploadFeaturedCategoryImageToS3BucketMutation,

  //Colors
  useUpdateColorPaletteMutation,
  useGetTemplateColorPalettesQuery,
  useDeleteColorPaletteMutation,

  //Typography
  useGetTypographyDetailsQuery,
  useGetTemplateTypographyDetailsQuery,
  useUpdateTypographyDetailsMutation,
  useUpdateTemplateTypographyDetailsMutation,

  // Buttons
  useGetButtonDetailsQuery,
  useGetTemplateButtonDetailsQuery,
  useUpdateButtonDetailsMutation,
  useUpdateTemplateButtonsDetailsMutation,

  // Promotion Banner
  useGetPromotionBannerDataQuery,
  useUpdatePromotionBannerDataMutation,

  usePublishWebsiteMutation,
  useGetOrdersMutation,
  useLoadToPOSMutation,
  usePublishWebsiteByFloristMutation,
  useUpdateAnalyticsIdMutation,
  useGetTemplateDetailsByFloristIdQuery,
  useGetPageSeoDataQuery,
  useUpdatePageSeoDataMutation,
  useGetFinancialReportQuery,
  useLazyGetFinancialReportQuery,
  useGetOrderDetailsQuery,

  // shopcart settings
  useGetShopCartSetttingsQuery,
  useUpdateShopCartSetttingsMutation,
  useRefundOrderMutation,
  useGenerateOrderReportMutation,
  useGenerateSalesReportMutation,
  useGetImageCategoriesMutation,
  useUpdateImageCategoriesInBulkMutation,
} = vendorsApiSlice;
